import {
  useMutation,
  type UseMutationOptions,
  useQueryClient
} from "@tanstack/react-query";
import { useSearch } from "@tanstack/react-router";

import type { DeleteVoucherRequestDto } from "../../dtos/delete-voucher-request-dto";
import { VoucherQueryKeys } from "../../generators/voucher-query-keys";
import { VoucherService } from "../../services/voucher-service";

type UseDeleteVoucherMutationParams = {
  options?: UseMutationOptions<
    { success: boolean },
    unknown,
    DeleteVoucherRequestDto
  >;
};

export const useDeleteVoucherMutation = ({
  options
}: UseDeleteVoucherMutationParams = {}) => {
  const queryClient = useQueryClient();
  const { q, page, sort } = useSearch({ from: "/vouchers/" });

  return useMutation({
    mutationFn: async (payload) => {
      return await VoucherService.deleteVoucher({ payload });
    },
    onSuccess: async (...args) => {
      const currentPageKey = VoucherQueryKeys.getVoucherList({
        limit: 10,
        page,
        q,
        sort
      }).queryKey;

      await queryClient.invalidateQueries({ queryKey: currentPageKey });

      options?.onSuccess?.(...args);
    },
    ...options
  });
};
